import type {InviaType} from '@/redux/v1/models';
import type {ExtractPropsWithoutRef} from '@/types';

import {IconNoMeals, IconRestaurant} from '@travel-frontend/icons';
import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {areAllBoardTypesEqual} from '@/modules/common/hooks/useBoardType/utils';
import {isBoardTypeNoBoard} from '@/utils/inviaType';

export const useBoardType = (rooms: Array<{boardType: InviaType}>) => {
  const {t} = useTranslation(['general']);

  return useMemo(() => {
    let boardType = '';
    let isBoardTypeEqual = true;
    let BoardTypeIcon:
      | ((
          p: {style?: React.CSSProperties} & ExtractPropsWithoutRef<
            typeof IconRestaurant
          >
        ) => null)
      | React.ExoticComponent = () => null;

    if (rooms.length > 0) {
      const [firstRoom] = rooms;
      isBoardTypeEqual = rooms.length === 1 || areAllBoardTypesEqual(rooms);

      boardType = isBoardTypeEqual
        ? firstRoom.boardType.name
        : t('general:boardType');

      const noBoardIcon = isBoardTypeNoBoard(firstRoom.boardType.type)
        ? IconNoMeals
        : IconRestaurant;

      BoardTypeIcon = isBoardTypeEqual ? noBoardIcon : IconRestaurant;
    }

    return {boardType, BoardTypeIcon, isBoardTypeEqual};
  }, [rooms, t]);
};
